interface ToastProps {
  title: string;
  timeAgo?: string;
  message?: string;
}

const Toast = ({ title, timeAgo, message }: ToastProps) => {
  return (
    <div className="w-full flex flex-col gap-px py-2.5 px-3.5 bg-surface-dark rounded-[0.875rem] backdrop-blur-md mb-2 shadow-xs shadow-white/10">
      <div className="flex items-center gap-2">
        <p className="flex-1 text-[0.8125rem] leading-[1rem] text-left text-white font-semibold truncate">
          {title}
        </p>
        {timeAgo && (
          <p className="shrink-0 text-[0.8125rem] leading-[1rem] text-right text-secondary-hint">
            {timeAgo}
          </p>
        )}
      </div>
      {message && (
        <p className="text-[0.8125rem] leading-[1rem] text-left text-white">{message}</p>
      )}
    </div>
  );
};

export default Toast;
